import { Badge } from './ui/badge';

export function ApplicableTariffsBadges({ tariffs, applicable }) {
  if (applicable && applicable.length > 0) {
    return (
      <div className="flex flex-wrap gap-1 mt-1">
        <span className="text-xs text-slate-500">Tariffs:</span>
        {applicable.map(function(tid) {
          var t = tariffs.find(function(tt) { return tt.id === tid; });
          return <Badge key={tid} variant="outline" className="text-xs">{t ? t.tariff_code : tid.slice(0, 8)}</Badge>;
        })}
      </div>
    );
  }
  return <p className="text-xs text-slate-400 mt-1">Applies to all tariffs</p>;
}
